export default "__VITE_ASSET__CXgzcUfg__"